import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as documentTypeState from '../static-data.reducer';
import * as documentTypeReducer from '../reducers/document-type.reducer';

export const getDocumentTypes = createSelector(documentTypeState.selectDocumentTypeState, documentTypeReducer.getDocumentType);
